import { render, staticRenderFns } from "./EmployeesGotMaximumAbsenceLimit.vue?vue&type=template&id=4415bbad&scoped=true"
import script from "./EmployeesGotMaximumAbsenceLimit.vue?vue&type=script&lang=js"
export * from "./EmployeesGotMaximumAbsenceLimit.vue?vue&type=script&lang=js"
import style0 from "./EmployeesGotMaximumAbsenceLimit.vue?vue&type=style&index=0&id=4415bbad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4415bbad",
  null
  
)

export default component.exports